import { ContainerBadgeComponent } from '@modules/common/components/container-badge/container-badge.component';
import { DetailBreadcrumbsComponent } from '@modules/common/components/detail-breadcrumbs/detail-breadcrumbs.component';
import { RowStatusMarkComponent } from '@modules/team-list-state/row-status-mark.component';
import { ItemReviewComponent } from '@modules/common/components/item-review/item-review.component';
import { ItemHandoverComponent } from '@modules/common/components/item-handover/item-handover.component';
import { CanPurgeTeamItemPipe } from '@modules/common/pipes/can-purge-team-item.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AlertComponent } from '@frontendlib/components/components/alert/alert.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';
import { ContextMenuDividerComponent } from '@frontendlib/components/features/popover/components/context-menu-divider/context-menu-divider.component';
import { ContextMenuHeadingComponent } from '@frontendlib/components/features/popover/components/context-menu-heading/context-menu-heading.component';
import { ContextMenuItemComponent } from '@frontendlib/components/features/popover/components/context-menu-item/context-menu-item.component';
import { ContextMenuWindowComponent } from '@frontendlib/components/features/popover/components/context-menu-window/context-menu-window.component';
import { ContextMenuStateIndicatorComponent } from '@frontendlib/components/features/popover/components/context-menu-state-indicator/context-menu-state-indicator.component';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LoadingIndicatorComponent } from '@frontendlib/components/components/loading-indicator/loading-indicator.component';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { SearchLocationBadgeComponent } from '@frontendlib/components/components/search-location-badge/search-location-badge.component';
import { AttachmentsModule } from '@modules/attachments/attachments.module';
import { CommentsModule } from '@modules/comments/comments.module';
import { StitchTimestampsComponent } from '@modules/common/components/stitch-timestamps/stitch-timestamps.component';
import { ConnectionsModule } from '@modules/connections/connections.module';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { KnotsModule } from '@modules/knots/knots.module';
import { ScrollModule } from '@modules/scroll/scroll.module';
import { SplitViewModule } from '@modules/split-view/split-view.module';
import { TagsModule } from '@modules/tags/tags.module';
import { UtilsModule } from '@modules/utils/utils.module';
import { EditorModule } from '@hugerte/hugerte-angular';
import { CommonModule as AppCommonModule } from '../common/common.module';
import { ElementsModule } from '../elements/elements.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';

// Components
import { MatIconModule } from '@angular/material/icon';
import { ItemDescriptionFieldComponent } from '@modules/common/components/item-description/item-description-field.component';
import { ListItemSeparatorComponent } from '@modules/common/components/list/list-items-separator/list-items-separator.component';
import { ListLoadErrorComponent } from '@modules/common/components/list/list-load-error/list-load-error.component';
import { ListSelectionBarComponent } from '@modules/common/components/list/list-selection-bar/list-selection-bar.component';
import { Pagination2Component } from '@modules/common/components/pagination/pagination2.component';
import { SendAfterContextMenuComponent } from '@modules/common/components/send-after-context-menu/send-after-context-menu.component';
import { SidebarItemComponent } from '@modules/common/components/sidebar-item/sidebar-item.component';
import { KnowledgeMarkerSelectionTooltipDirective } from '@modules/common/directives/knowledge-marker-selection-tooltip.directive';
import { TooltipDirective } from '@modules/tooltip/tooltip.directive';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { LinkedInfoListComponent } from '@modules/elements/components/link-info/linked-info-list/linked-info-list.component';
import { EntityHubSearchComponent } from '@modules/elements/components/entity-hub/entity-hub-search/entity-hub-search.component';
import { StitchHubComponent } from '@modules/elements/components/stitch-hub/stitch-hub.component';
import { MessageFolderQuickFormComponent } from '@modules/elements/components/quick-forms/message-folder-quick-form/message-folder-quick-form.component';
import { MessageQuickFormComponent } from '@modules/elements/components/quick-forms/message-quick-form/message-quick-form.component';
import { EditableTextareaComponent } from '@modules/form-controls/components/editable-textarea/editable-textarea.component';
import { QuickActionComponent } from '@modules/form-controls/components/quick-action/quick-action.component';
import { MailBodyComponent } from '@modules/mail/components/mail-body/mail-body.component';
import { ComposeAttachmentsComponent } from '@modules/elements/components/compose-attachments/compose-attachments.component';
import { OutboundKnotsControlComponent } from '@modules/messages/components/outbound-knots-control/outbound-knots-control.component';
import { MessagesSideBarComponent } from '@modules/messages/components/side-bar/side-bar.component';
import { ToArrayPipe } from '@modules/utils/pipes/array/to-array.pipe';
import { ContactsInlineListComponent } from './components/contacts-inline-list/contacts-inline-list.component';
import { FoldersListContextMenuComponent } from './components/folders-list-context-menu/folders-list-context-menu.component';
import { MessageFoldersListComponent } from './components/folders-list/folders-list.component';
import { MessagesListContainerComponent } from './components/list-container/list-container.component';
import { MessageComposeComponent } from './components/message-compose/message-compose.component';
import { MessageConnectionsComponent } from './components/message-connections/message-connections.component';
import { MessageFolderFormComponent } from './components/message-folder-form/message-folder-form.component';
import { MailInvitationCardComponent } from './components/message-form/mail-invitation-card/mail-invitation-card.component';
import { MailReaderSkeletonComponent } from './components/mail-reader-skeleton/mail-reader-skeleton.component';
import { MessageFormComponent } from './components/message-form/message-form.component';
import { MessagesListContextMenuComponent } from './components/messages-list-context-menu/messages-list-context-menu.component';
import { MessagesListComponent } from './components/messages-list/messages-list.component';
import { MessagesMainViewComponent } from './components/messages-main-view/messages-main-view.component';
import { ParticipantContextMenuComponent } from './components/participant-context-menu/participant-context-menu.component';
import { SideBarFoldersTreeComponent } from './components/side-bar-folders-tree/side-bar-folders-tree.component';
import { SideBarFoldersComponent } from './components/side-bar-folders/side-bar-folders.component';
import { SidebarContextMenuComponent } from './components/sidebar-context-menu/sidebar-context-menu.component';
import { RailMenuComponent } from '@modules/common/components/rail-menu/rail-menu.component';
import { MessagesFoldersListContextMenuDirective } from './directives/messages-folders-list-context-menu.directive';
import { MessagesListContextMenuDirective } from './directives/messages-list-context-menu.directive';
import { ParticipantContextMenuDirective } from './directives/participant-context-menu.directive';
import { SidebarContextMenuDirective } from './directives/sidebar-context-menu.directive';
import { EnsureFwdPrefixPipe } from './pipes/ensure-fwd-prefix.pipe';
import { EnsureRePrefixPipe } from './pipes/ensure-re-prefix.pipe';
import { FormatParticipantPipe } from './pipes/format-participant.pipe';
import { FormatSendLaterPipe } from './pipes/format-send-later.pipe';
import { TitleByMessagesFilterPipe } from './pipes/title-by-messages-filter.pipe';

@NgModule({
  imports: [
    ContainerBadgeComponent,
    DetailBreadcrumbsComponent,
    RowStatusMarkComponent,
    RailMenuComponent,
    ItemReviewComponent,
    ItemHandoverComponent,
    CanPurgeTeamItemPipe,
    SearchLocationBadgeComponent,
    AppCommonModule,
    AttachmentsModule,
    BrowserAnimationsModule,
    CommentsModule,
    CommonModule,
    ConnectionsModule,
    DragNDropModule,
    EditorModule,
    ElementsModule,
    FormControlsModule,
    FormsModule,
    KnotsModule,
    MatIconModule,
    MatTooltipModule,
    TooltipDirective,
    ContextMenuDividerComponent,
    ContextMenuHeadingComponent,
    ContextMenuItemComponent,
    ContextMenuWindowComponent,
    ContextMenuStateIndicatorComponent,
    PopoverDirective,
    ReactiveFormsModule,
    RouterModule,
    ScrollModule,
    ScrollingModule,
    SplitViewModule,
    TagsModule,
    UserAvatarModule,
    UtilsModule,
    FormatParticipantPipe,
    EnsureRePrefixPipe,
    EnsureFwdPrefixPipe,
    ListItemSeparatorComponent,
    NoContentStubComponent,
    ListLoadErrorComponent,
    LoadingIndicatorComponent,
    ListSelectionBarComponent,
    Pagination2Component,
    QuickActionComponent,
    ToArrayPipe,
    LinkedInfoListComponent,
    EntityHubSearchComponent,
    StitchHubComponent,
    MessageFolderQuickFormComponent,
    MessageQuickFormComponent,
    OutboundKnotsControlComponent,
    ComposeAttachmentsComponent,
    Button2Component,
    EditableTextareaComponent,
    ItemDescriptionFieldComponent,
    KnowledgeMarkerSelectionTooltipDirective,
    StchHighlightTextDirective,
    IconComponent,
    SidebarItemComponent,
    MailBodyComponent,
    MailInvitationCardComponent,
    MailReaderSkeletonComponent,
    SendAfterContextMenuComponent,
    DateFormatPipe,
    // Newly converted standalone components
    AlertComponent,
    ContactsInlineListComponent,
    MessageConnectionsComponent,
    ParticipantContextMenuDirective,
    StitchTimestampsComponent,
  ],
  exports: [
    // Components
    MessageComposeComponent,
    MessageFolderFormComponent,
    MessageFoldersListComponent,
    MessageFormComponent,
    MessagesListComponent,
    MessagesListContainerComponent,
    MessagesMainViewComponent,
    MessagesSideBarComponent,
    // Directives
    MessagesFoldersListContextMenuDirective,
    MessagesListContextMenuDirective,
    // Pipes
    TitleByMessagesFilterPipe,
  ],
  declarations: [
    // Components
    FoldersListContextMenuComponent,
    MessageComposeComponent,
    MessageFolderFormComponent,
    MessageFoldersListComponent,
    MessageFormComponent,
    MessagesListComponent,
    MessagesListContainerComponent,
    MessagesListContextMenuComponent,
    MessagesMainViewComponent,
    MessagesSideBarComponent,
    ParticipantContextMenuComponent,
    SideBarFoldersComponent,
    SideBarFoldersTreeComponent,
    SidebarContextMenuComponent,

    // Directives
    MessagesFoldersListContextMenuDirective,
    MessagesListContextMenuDirective,
    SidebarContextMenuDirective,
    // Pipes
    TitleByMessagesFilterPipe,
    FormatSendLaterPipe,
  ],
  providers: [FormatParticipantPipe, EnsureRePrefixPipe, EnsureFwdPrefixPipe],
})
export class MessagesModule {}
